import type React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { IncidentSeverity } from 'types';
import { useSeverityBadgeStyles } from './SeverityBadge.styles';

interface SeverityBadgeProps {
  severity: IncidentSeverity;
  size?: 'medium' | 'large';
}

const severityStyleMap: Record<IncidentSeverity, string> = {
  [IncidentSeverity.High]: 'high',
  [IncidentSeverity.Medium]: 'medium',
  [IncidentSeverity.Low]: 'low',
  [IncidentSeverity.Informational]: 'informational',
};

export const SeverityBadge: React.FC<SeverityBadgeProps> = ({ severity, size = 'medium' }) => {
  const styles = useSeverityBadgeStyles();
  const { t } = useTranslation();

  const severityClass = severityStyleMap[severity] as keyof ReturnType<typeof useSeverityBadgeStyles>;
  const sizeClass = size === 'large' ? styles.large : undefined;

  return (
    <span className={mergeClasses(styles.root, styles[severityClass], sizeClass)}>
      {t(`statusPanel.severity.${severity}`)}
    </span>
  );
};
